export default __webpack_public_path__ + "be2614f717c3ad80a691dbc113690460.svg";